import BvBtnGroup from 'volta/components/bv-btn-group';
import { t } from 'ember-intl';

import type { TOC } from '@ember/component/template-only';

interface CollectionViewUnsavedSignature {
  Args: {
    isDefault: boolean;
    onDiscard?: (e: Event) => void;
    onSave?: (e: Event) => void;
  };
  Element: HTMLDivElement;
}

const CollectionViewUnsavedComponent: TOC<CollectionViewUnsavedSignature> = <template>
  <div ...attributes>
    <BvBtnGroup @segmented={{false}} as |g|>
      <g.btn
        @onClick={{@onDiscard}}
        @tooltipText={{t 'discard'}}
        @subtle={{true}}
        @iconLeft='undo'
      />
      {{#if @onSave}}
        <g.btn
          @onClick={{@onSave}}
          @text={{t (if @isDefault 'duplicate' 'save')}}
          class='u-color-primary'
        />
      {{/if}}
    </BvBtnGroup>
  </div>
</template>;

export default CollectionViewUnsavedComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::Unsaved': typeof CollectionViewUnsavedComponent;
    'collection-view/unsaved': typeof CollectionViewUnsavedComponent;
  }
}
